module.exports = __webpack_public_path__ + "img/V-R-2-unload-standup-shadow.4c736844.png";